<template>
  <div class="page">
    <div class="poster" style="max-width: 1600px; margin: auto; margin-bottom: 0px; margin-top: 0px;">
      <div style="padding:56.25% 0 0 0;position:relative; width: 100%;">
        <iframe src="https://player.vimeo.com/video/1130474003?h=99ec7de282&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerpolicy="strict-origin-when-cross-origin" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="Berget 22 Story teaser"></iframe>
        <script type="application/javascript" src="https://player.vimeo.com/api/player.js"></script>
      </div>
    </div>
    <div class="segment">
      <div class="content narrow">
        <!-- <div class="header">BERGET 19 <span class="text-highlight">STORY</span></div> -->
        <!-- POST 1 -->
        <div class="post column">

          <div class="post-content-wrapper">

            <div class="post-header">Story</div>

            <pre class="post-content">
              In the cold north of Europe, a storm is coming. Nordland is a nation in decline - its economy shattered, its welfare system gone, and its people left to starve while the elite hide their fortunes abroad. Corruption, hunger, and unrest have driven the country to the brink of civil war. But deep in the northern wilderness lies the secret Nordland Riksbank Gold Reserve. Several underground vaults hold the last true wealth of the nation - and whoever controls it will shape Nordland’s future.

              The Nordland Defence Group (NDG) stands ready to defend it. Once the nation’s army, now a self-commanded force without stable political leadership, they remain disciplined, professional, and bound by duty. They fight under the old codes - order, restraint, and protection of the people. They guard the vaults, the infrastructure, and what little remains of law in a collapsing country.

              Opposing them is a breakaway military Mercenary faction led by Colonel Jari Koskinen. They believe Nordland can only be rebuilt through strength and control. To them, the gold is not plunder but the foundation of a new order - one forged through power, not compromise. “Might is Right” is their creed.

              Between the two warring factions, Nordland’s roads and settlements have become lawless ground. The Odin’s Wolves MC, ruthless drug runners and ex-soldiers, dominate the northern routes with firepower and intimidation, enforcing their trade threats and violence.

              The Sons of the North, operating more like a criminal syndicate than a gang, control smuggling, extortion, and black-market trade through networks of influence and fear. Power and profit dictate every alliance - and in a land without law, both groups command respect through violence, money, and control.

              Despite the lack of a functioning state government, regional elections are still held to elect a county governor. In most regions, law and order prevail on the surface.

              The poor and desperate people of the region would do anything to come across a gold bar.

              For an individual, a gold bar can feed a family for years.

              Now, all groups converge on the same objective. The gold vaults are fortified, the defenders are armed, but will reinforcements arrive in time?

              Operation Fort Knox - Secure the gold. Control the future.
            </pre>

          </div>

        </div>

        <div class="poster">
          <img src="../assets/2026/Berget-2026.jpg">
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Story'
}
</script>
